import { useCallback, useState } from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { getConfig } from 'src/utilities/config';
import { pushError } from 'src/utilities/notifications';
import { MediaTypes, saveFile } from 'src/utilities/saveFile';
import {
  getCsvTemplateAssetName,
  getCsvTemplateDownloadName,
} from 'src/components/enterprise/features/Employee/EmployeeUploadPage/components/DownloadCsvTemplate/downloadCsvTemplate.utils';
import { DOWNLOAD_CSV_TEMPLATE_ERROR } from 'src/components/enterprise/features/Employee/EmployeeUploadPage/components/DownloadCsvTemplate/constants';

type UseDownloadCsvTemplateReturn = {
  downloadCsvTemplate: () => Promise<void>;
  isDownloading: boolean;
};

export function useDownloadCsvTemplate(): UseDownloadCsvTemplateReturn {
  const { corpData } = useAuth();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadCsvTemplate = useCallback(async (): Promise<void> => {
    try {
      setIsDownloading(true);

      const assetName = getCsvTemplateAssetName(corpData);
      const response = await fetch(`${getConfig().assetsURL}/${assetName}`);

      if (!response.ok) {
        throw new Error(`Unable to load CSV template ${assetName}`);
      }

      const template = await response.text();

      saveFile(
        template,
        getCsvTemplateDownloadName(corpData),
        MediaTypes.TEXT_CSV
      );
    } catch (error) {
      pushError(DOWNLOAD_CSV_TEMPLATE_ERROR);
    } finally {
      setIsDownloading(false);
    }
  }, [corpData]);

  return { downloadCsvTemplate, isDownloading };
}
